import React, { useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';

import { Table, UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  findData,
  recordFiltering,
} from '~/store/modules/saldoCotaOrgaoLista/actions';
import api from '~/services/api';

import * as S from './styles';

function SaldoCotaOrgaoLista() {
  const data = useSelector((state) => state.saldoCotaOrgaoLista);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  const header = useMemo(
    () => [
      {
        id: 'orga_codigo',
        label: 'Órgão Código',
        filter: { type: 'text' },
      },
      {
        id: 'orga_nome',
        label: 'Nome do Órgão',
        filter: { type: 'text' },
      },
    ],
    []
  );

  const headerSimple = useMemo(
    () => [
      { id: 'prod_codigo', label: 'Cód. Produto' },
      { id: 'prod_descricao', label: 'Nome Produto' },
      { id: 'coor_saldo', label: 'Saldo' },
    ],
    []
  );

  const handleGetAPI = useCallback(async (id) => {
    setLoading(true);

    try {
      if (!id) setItems([]);
      else {
        const response = await api.get(`orgaocotasaldo/total/${id}`);
        setItems(response.data);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));

      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <S.Wrapper>
      <UnidataTable
        pdf
        excel
        dense
        maxHeight="45vh"
        reportOrder="orga_nome ASC"
        fixed
        read={recordFiltering}
        redux={data}
        header={header}
        find={findData}
        detach="orga_nome"
        keys="orga_codigo"
        onRow={({ orga_codigo }) => handleGetAPI(orga_codigo)}
        create={false}
        update={false}
        delete={false}
        view="VW_ORGAO"
        reportTitle="Saldo Cota Orgão Lista"
      />

      <Table
        cells={headerSimple}
        data={items}
        loading={loading}
        size="small"
        unique="prod_codigo"
      />
    </S.Wrapper>
  );
}

export default SaldoCotaOrgaoLista;
